<template>
    <div>
        <div class="top-stripe"></div>
        <StepIndicator
        
        />
        <GameTitle
        :titleText = "titleText"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StepIndicator from '@/components/game/StepIndicator.vue'
import GameTitle from '@/components/game/GameTitle.vue'

export default {
    name: 'GameHeader',
    components:{
        StepIndicator,
        GameTitle
    },
    computed: {
        ...mapGetters([
            'stepNumber',
            'actualView'
        ]), 
        titleText(){
            return this.actualView.title
        }
    }
}
</script>

<style>
    
</style>